"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ko_KR = _interopRequireDefault(require("../../date-picker/locale/ko_KR"));
var _default = _ko_KR["default"];
exports["default"] = _default;